import React from "react";

const TicketsToReviewPanel = () => {
  return (
    <div>
      <div>functions : que , ban and unsubscribe</div>
      tickets to review
      <div>ban account button</div>
      <div>put account on hold button</div>
      <div>notify of report button</div>
      <div>trash ticket button</div>
    </div>
  );
};

export default TicketsToReviewPanel;
